
<div class="sidebar">
  <img src="assets/logos/logo-white.png" class="logo" alt="logo" routerLink="/home">
  <div class="item-container">
    @for (item of navList; track item.id) {
      <div class="sidebar-item d-flex align-items-center gap-3" (click)="routeClick(item)"
           [ngClass]="routeSelected == item.id ? 'selected-item' : ''"

      >
        <svg-icon [src]="'assets/icons/' + item.icon + (routeSelected == item.id ? '-yellow': '-white') + '.svg'"></svg-icon>
        <div class="item-label">{{ item.label }}</div>
      </div>
    }
  </div>
</div>
